import { PlanSectionSkeleton } from "./PlanSectionSkeleton";
import { CreditsSectionSkeleton } from "./CreditsSectionSkeleton";
import { PaymentHistorySectionSkeleton } from "./PaymentHistorySectionSkeleton";

interface MembershipDashboardSkeletonProps {
  variant?: "default" | "compact";
}

export function MembershipDashboardSkeleton({
  variant = "default",
}: MembershipDashboardSkeletonProps) {
  if (variant === "compact") {
    return (
      <section className="min-w-0">
        <div className="border-y border-gray-100 py-4">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex min-w-0 items-center gap-3">
              <div className="h-9 w-9 shrink-0 animate-pulse rounded-xl bg-gray-100" />
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <div className="h-5 w-32 animate-pulse rounded-md bg-gray-100" />
                  <div className="h-5 w-16 animate-pulse rounded-full bg-gray-100" />
                </div>
              </div>
            </div>
            <div className="h-9 w-28 animate-pulse rounded-xl bg-gray-100" />
          </div>

          <div className="mt-4 grid gap-3 sm:grid-cols-3">
            {[0, 1, 2].map((item) => (
              <div
                key={item}
                className="flex items-center justify-between gap-3 rounded-xl bg-white px-3 py-2.5 ring-1 ring-gray-200"
              >
                <div className="h-3.5 w-20 animate-pulse rounded bg-gray-100" />
                <div className="h-4 w-16 animate-pulse rounded bg-gray-100" />
              </div>
            ))}
          </div>
        </div>

        <div className="border-b border-gray-100 py-4">
          <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <div className="h-5 w-5 animate-pulse rounded-full bg-gray-100" />
              <div className="h-5 w-20 animate-pulse rounded-md bg-gray-100" />
            </div>
            <div className="h-9 w-28 animate-pulse rounded-xl bg-gray-100" />
          </div>

          <div className="grid gap-4 lg:grid-cols-[190px_1fr] lg:items-center">
            <div>
              <div className="h-9 w-24 animate-pulse rounded-md bg-gray-100" />
              <div className="mt-2 h-4 w-28 animate-pulse rounded bg-gray-100" />
            </div>
            <div>
              <div className="mb-2 flex items-center justify-between">
                <div className="h-4 w-24 animate-pulse rounded bg-gray-100" />
                <div className="h-4 w-10 animate-pulse rounded bg-gray-100" />
              </div>
              <div className="h-2 w-full animate-pulse rounded-full bg-gray-100" />
              <div className="mt-2 h-3.5 w-48 animate-pulse rounded bg-gray-100" />
            </div>
          </div>
        </div>

        <div className="border-y border-gray-100 py-4">
          <div className="mb-3 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 animate-pulse rounded-xl bg-gray-100" />
              <div className="h-5 w-36 animate-pulse rounded-md bg-gray-100" />
            </div>
            <div className="h-4 w-5 animate-pulse rounded bg-gray-100" />
          </div>

          <div className="border-t border-gray-100">
            {[0, 1, 2].map((item) => (
              <div
                key={item}
                className="flex items-center justify-between gap-4 border-b border-gray-100 py-3 last:border-b-0"
              >
                <div className="min-w-0">
                  <div className="h-5 w-20 animate-pulse rounded bg-gray-100" />
                  <div className="mt-2 h-3.5 w-40 animate-pulse rounded bg-gray-100" />
                </div>
                <div className="shrink-0 space-y-2">
                  <div className="ml-auto h-3.5 w-20 animate-pulse rounded bg-gray-100" />
                  <div className="ml-auto h-5 w-16 animate-pulse rounded-full bg-gray-100" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2 space-y-8">
        <PlanSectionSkeleton />
        <PaymentHistorySectionSkeleton />
      </div>

      <div className="lg:col-span-1">
        <CreditsSectionSkeleton />
      </div>
    </div>
  );
}
